// extracted by mini-css-extract-plugin
export var scrollToTop = "ScrollToTop--scrollToTop--tnybH";
export var tkMyriadProSemiCondensed = "ScrollToTop--tk-myriad-pro-semi-condensed--2TYtT";